import { Image, Link, Text, VStack } from '@chakra-ui/react';
import * as React from 'react';

import { CommunityMovedInfo } from '@/utils/fetchCommunityMoved';

export const NoTenantFound: React.FC<{
  communityMoved?: CommunityMovedInfo | null;
}> = ({ communityMoved }) => {
  if (communityMoved) {
    const communityName = communityMoved.displayName || 'This community';

    return (
      <VStack p="12" spacing="4" textAlign="center">
        <Image
          src="https://tradewing-public.s3.us-east-2.amazonaws.com/tradewing-logo.png"
          alt="Tradewing"
          width="50px"
          height="50px"
        />
        <Text textStyle="xlBodyStrong">This site has moved</Text>
        <Text>
          The <b>{communityName}</b> is now available at a new address:{' '}
          <Link
            href={communityMoved.destinationUrl}
            color="blue.600"
            textDecoration="underline"
          >
            {communityMoved.destinationDomain}
          </Link>{' '}
        </Text>

        <Text>
          We recommend updating your bookmarks to use the new address going
          forward.
        </Text>
      </VStack>
    );
  }

  return (
    <VStack p="12" spacing="4" textAlign="center">
      <Image
        src="https://tradewing-public.s3.us-east-2.amazonaws.com/tradewing-logo.png"
        alt="Tradewing"
        width="50px"
        height="50px"
      />
      <Text textStyle="xlBodyStrong">Community Not Found</Text>
      <Text>No Tradewing community exists with this name.</Text>
      <Text>
        Please check your web address and try again. If you need help locating
        your community, please contact support@tradewing.com.
      </Text>
    </VStack>
  );
};
